/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';
let exports = {};

// ====================== 消息订阅管理 ======================
exports.getBizEventMsgInfo = function (params, callback) {// 获取 -业务事件消息
    api.get('/bizMsg/biz/event/msg/info/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.getBizTopicList = function (data, callback) {// 获取 业务主题--业务事件消息
    api.post('/bizMsg/biz/topic/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.checkBizEventMsgForVip = function (params, callback) {// 消息订阅管理 - 检查是否符合vip等级
    api.post('/bizMsg/biz/event/msg/vip/check')
    .params(params)
    .done(callback)
    .go();
};
//
exports.getBizEventMsgSubscrPageList = function (data, callback) {  // 已订阅消息 分页列表
    api.post('/bizMsg/biz/event/msg/subscr/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getBizEventMsgSubscrList = function (data, callback) {  // 已订阅消息 列表
    api.post('/bizMsg/biz/event/msg/subscr/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.saveBizEventMsgSubscrs = function (data, callback) {// 新增 - 业务事件消息消息订阅
    api.post('/bizMsg/biz/event/msg/subscr/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteBizEventMsgById = function (params, callback) {// 取消 - 业务事件消息消息订阅
    api.post('/bizMsg/biz/event/msg/subscr/delete/do')
    .params(params)
    .done(callback)
    .go();
};
//
exports.getBizEventMsgAppList = function (params, callback) {// 获取业务事件消息小程序 - 列表
    api.get('/bizMsg/biz/event/msg/App/list/get')
    .params(params)
    .done(callback)
    .go();
};
exports.getBizEventMsgAppListByMsgIds = function (params, callback) {// 获取业务事件消息小程序 - 列表-根据事件ids
    api.post('/bizMsg/biz/event/msg/App/list/get/by/msgIds')
    .data(params)
    .done(callback)
    .go();
};
//
exports.saveBizEventMsgSubscrList = function (data, callback) {// 批量订阅消息
    api.post('/bizMsg/biz/event/msg/subscr/list/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getTopicSubscrList = function (params, callback) {// 结构化查看已订阅信息
    api.get('/bizMsg/subscr/msg/list/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.saveBizEventMsgSubscrsForCopy = function (data, callback) {// 复制 - 消息订阅
    api.post('/bizMsg/copy/biz/event/msg/subscr/save/do')
    .data(data)
    .done(callback)
    .go();
};
// =========================== 业务事件消息订阅模版 ============================
// 获取消息订阅模版-分页列表
exports.getBizEventMsgSubscrTplList = function (data, callback) {
    api.post('/bizMsg/subscr/tpl/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取消息订阅模版-根据id
exports.getBizEventMsgSubscrTplById = function (data, callback) {
    api.get('/bizMsg/subscr/tpl/get/by/id')
    .params(data)
    .done(callback)
    .go();
};
// 保存消息订阅模版
exports.saveBizEventMsgSubscrTpl = function (data, callback) {
    api.post('/bizMsg/subscr/tpl/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 修改消息订阅模版
exports.updateBizEventMsgSubscrTpl = function (data, callback) {
    api.post('/bizMsg/subscr/tpl/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除消息订阅模版
exports.deleteBizEventMsgSubscrTpl = function (data, callback) {
    api.post('/bizMsg/subscr/tpl/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存消息模版订阅
exports.saveBizEventMsgTplSubscr = function (data, callback) {
    api.post('/bizMsg/tpl/subscr/list/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取消息模版订阅列表
exports.getBizEventMsgTplSubscrList = function (data, callback) {
    api.get('/bizMsg/tpl/subscr/list/get')
    .params(data)
    .done(callback)
    .go();
};
// 员工订阅消息模版
exports.doBizEventMsgSubscrTplSetStaff = function (data, callback) {
    api.post('/bizMsg/subscr/tpl/set/staff')
    .data(data)
    .done(callback)
    .go();
};
// 商户岗位模板-同步消息订阅
exports.doSyncBizEventMsgSubscrTpl = function (data, callback) {
    api.post('/bizMsg/tpl/subscr/for/mercht/tpl/role')
    .data(data)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/bizMsg.js
// module id = 98
// module chunks = 0